export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Coat maps',
  'Body-zone diagrams',
  'Tool-positioning guides',
  'Clipper-direction maps',
  'Blade and length planning',
  'Scissor-angle breakdowns',
  'Coat preparation sequences',
  'Head-shaping systems',
  'Leg-shaping guides',
  'Foot-finishing techniques',
  'Body-to-leg transitions',
  'Breed styling examples',
  'Before / during / after sequences',
  'Correct-vs-incorrect comparisons',
  'Common student mistakes',
  'Quick corrections',
  'Instructor cue cards',
  'Progression maps',
  'Assessments',
  'Checklists',
  'Quick-reference tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nYnDTNq2bQrRwdMoNTNET8/Captura_de_pantalla_2026-10-13_003231.png',
    alt: 'Common error: hard transition lines — where they appear and how to fix them, with a correction map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4GEuAfpU8iQBAkybUnc98u/Captura_de_pantalla_2026-10-13_003210.png',
    alt: 'One dog, three finish options: short practical, balanced pet style and fuller sculpted finish',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/do9c5BgBnms8W5MYPQzQon/Captura_de_pantalla_2026-10-13_003138.png',
    alt: 'Breed style: Schnauzer-type silhouette — body contrast, furnishings and beard balance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t2xQbHBLi4epyemvQme87Q/Captura_de_pantalla_2026-10-13_003116.png',
    alt: 'Build a round head: step-by-step head shaping sequence with tool tips and common error',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/g4Jp4Vt9AuRqMypthELLSw/Captura_de_pantalla_2026-10-13_003052.png',
    alt: 'Before, during and after: watch the grooming shape emerge at each stage',
  },
]
